export const appLabel = 'EntityViewer54';
const appLabelForDomain = 'entity-viewer';

const apiProdConfig = {
  entity: 'https://entity.p3.54origins.com',
  auth: 'https://auth.p3.54origins.com',
  'entity-viewer': 'https://entity-viewer.p3.54origins.com',
};

const apiConfigNewDev = {
  auth: 'https://auth.09releasetest.54origins.com',
  entity: ' https://entity.09releasetest.54origins.com',
  'entity-viewer': 'https://entity-viewer.09releasetest.54origins.com',
};

const apiConfig = apiConfigNewDev;

function replaceDynamic(search, replaceWith) {
  // Экранируем спецсимволы в `search` (если там есть точки, скобки и т. д.)
  const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Регулярка: ищем `search` в начале строки, после точки или после /
  const regex = new RegExp(`(^|\\.|\\/)${escapedSearch}(\\.|\\/|-)`, 'g');

  return window.location.origin.replace(regex, `$1${replaceWith}$2`);
}

export const replaceDomainByService = (service) => window.location.host.includes(appLabelForDomain) ? replaceDynamic(appLabelForDomain, service) : apiConfig[service]

export const configUrlEntity = replaceDomainByService('entity');
export const configUrlWMS = replaceDomainByService(appLabelForDomain);
export const configUrlAuth = replaceDomainByService('auth');
export const gptUrl = replaceDomainByService('gpt-proxy');
export const webSocketEntityURL = `wss://${new URL(configUrlEntity).hostname}/ws`;
